import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from 'primereact/checkbox';
import bgImage from '../../src/assets/images/bg.png';
import { handlePostRequest } from '../service/PostTemplate';
import { endPoints } from '../Config';
import * as Yup from 'yup';

const ForgetPassword = () => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState('');
    const [emailVerified, isEmailVerified] = useState(false);

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const emailvalidationSchema = Yup.object().shape({
        email: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .email('Invalid email')
            .required('This field is required')
    });
    const otpvalidationSchema = Yup.object().shape({
        otp: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
    });

    const formik = useFormik({
        validationSchema: !emailVerified ? emailvalidationSchema : otpvalidationSchema,

        initialValues: {
            email: '',
            otp: '',
            userId: ''
        },

        onSubmit: async (data) => {
            if (!emailVerified) {
                const emailData = {
                    emial: formik.values.email
                };

                const response = await dispatch(handlePostRequest(emailData, endPoints.verifyEmail, true));
                if (response?.status === 200 && response?.data?.data !== null) {
                    isEmailVerified(true);
                    formik.setFieldValue('userId', response?.data?.data?.userId);
                }
            } else {
                const otpData = {
                    email: formik.values.email,
                    otp: formik.values.otp,
                    userId: formik.values.userId
                };
                const response = await dispatch(handlePostRequest(otpData, endPoints.verifyOtp, true));
                if (response?.status === 200) {
                    navigate('/');
                }
            }
        }
    });

    const resendOtp = () => {};

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <div className="login-body">
            <div className="login-image">
                <img src={bgImage} alt="atlantis" />
            </div>
            <div className="login-panel p-fluid" style={{ background: '#fff' }}>
                <form onSubmit={formik.handleSubmit} className="">
                    {!emailVerified ? (
                        <div className="flex flex-column">
                            <div className="flex align-items-center mb-6 logo-container">
                                <p className="Signin__Heading">Verify Email</p>
                            </div>
                            <div className="form-container">
                                <div className="flex flex-column w-12">
                                    <span className="p-input-icon-left">
                                        <i className="pi pi-envelope"></i>
                                        <InputText
                                            type="email"
                                            id="email"
                                            className={classNames({ 'p-invalid': isFormFieldValid('email') }, 'Login__Input')}
                                            name="email"
                                            value={formik.values.email}
                                            placeholder="Enter Email"
                                            onChange={formik.handleChange}
                                        />
                                        {getFormErrorMessage('email')}
                                    </span>
                                </div>
                                {/* <div className="flex flex-column w-12 mt-2">
                                <span className="p-input-icon-left">
                                    <i className="pi pi-key"></i>
                                    <InputText
                                        className={classNames({ 'p-invalid': isFormFieldValid('password') }, 'Login__Input')}
                                        name="password"
                                        placeholder="Enter Password"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        type="password"
                                    />
                                    {getFormErrorMessage('password')}
                                </span>
                            </div> */}
                                <div className="Remember__Forget flex justify-content-end flex-wrap">
                                    {/* <div className="field-checkbox mt-1">
                                    <Checkbox inputId="binary" checked={checked} onChange={(e) => setChecked(e.checked)} className="checkbox_login" />
                                    <label style={{ cursor: 'pointer' }} htmlFor="binary" className="Remember_label">
                                        Remember Me
                                    </label>
                                </div> */}
                                    {/* <div className="mt-1">
                                    <label style={{ cursor: 'pointer' }} onClick={handleUrl} htmlFor="" className="forgot_label">
                                        Forgot Password
                                    </label>
                                </div> */}
                                </div>
                            </div>
                            <div className="button-container mt-4">
                                <Button type="submit" label="Submit" icon={loadingIcon || ''} iconPos="right" className="Login__Button" />
                            </div>
                        </div>
                    ) : (
                        <div className="flex flex-column">
                            <div className="flex align-items-center mb-6 logo-container">
                                <p className="Signin__Heading">Verify OTP</p>
                            </div>
                            <div className="form-container">
                                <div className="flex flex-column w-12">
                                    <span className="p-input-icon-left">
                                        <i className="pi pi-envelope"></i>
                                        <InputText type="otp" id="otp" className={classNames({ 'p-invalid': isFormFieldValid('otp') }, 'Login__Input')} name="otp" value={formik.values.otp} placeholder="Enter OTP" onChange={formik.handleChange} />
                                        {getFormErrorMessage('otp')}
                                    </span>
                                </div>
                                {/* <div className="flex flex-column w-12 mt-2">
                                <span className="p-input-icon-left">
                                    <i className="pi pi-key"></i>
                                    <InputText
                                        className={classNames({ 'p-invalid': isFormFieldValid('password') }, 'Login__Input')}
                                        name="password"
                                        placeholder="Enter Password"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        type="password"
                                    />
                                    {getFormErrorMessage('password')}
                                </span>
                            </div> */}
                                <div className="Remember__Forget flex justify-content-end flex-wrap">
                                    {/* <div className="field-checkbox mt-1">
                                    <Checkbox inputId="binary" checked={checked} onChange={(e) => setChecked(e.checked)} className="checkbox_login" />
                                    <label style={{ cursor: 'pointer' }} htmlFor="binary" className="Remember_label">
                                        Remember Me
                                    </label>
                                </div> */}
                                    <div className="mt-1">
                                        <label style={{ cursor: 'pointer' }} onClick={() => resendOtp()} htmlFor="" className="forgot_label font-bold">
                                            Resend OTP
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="button-container mt-4">
                                <Button type="submit" label="Submit" icon={loadingIcon || ''} iconPos="right" className="Login__Button" />
                            </div>
                        </div>
                    )}
                </form>

                {/* <div className="login-footer flex align-items-center">
          <div className="flex align-items-center login-footer-logo-container">
            <img
              src="assets/layout/images/logo-gray.png"
              className="login-footer-logo"
              alt="login-footer-logo"
            />
            <img
              src="assets/layout/images/appname-gray.png"
              className="login-footer-appname"
              alt="login-footer-appname"
            />
          </div>
          <span>Copyright 2021</span>
        </div> */}
            </div>
        </div>
    );
};

export default ForgetPassword;
